export const CREDIT_CARD = 'CREDIT CARD';
export const GIFT_CARD = 'GIFT CARD';
export const CASH = 'CASH';


